export const WHITE_COLOR = '#FFFFFF';
export const FOOTER_TEXT_COLOR = '#FFFFFF99';
export const BLACK_COLOR = '#000000';
export const SEARCH_INPUT_COLOR = '#FC0';
export const FOOTER_COLOR = '#343C50';
export const TITLE_COLOR = '#333333';
export const BOOK_ITEM_FOOTER_COLOR = '#F4F4F4';
export const FOOTER_LINK_COLOR = '#999999';
export const FOOTER_LINK_COLOR_HOVER = '#D00D00';
export const OVERLAY_COLOR = '#0000000D';
